import React, { useState } from 'react'
import { Button, Typography, Grid, Box, Backdrop, CircularProgress ,TextField} from '@mui/material'
import { Link, useNavigate } from 'react-router-dom';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { useEffect } from 'react';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import 'react-toastify/dist/ReactToastify.css';
import './SupportCenterManagementTable.scss';
import { DataGrid } from '@mui/x-data-grid';
import { tableStyle } from '../../../style/common';
import { cfpBaseUrl } from '../../../network/urls';
import CheckPermissions from '../../../authorization/authorization';
import BasicTable from '../../../components/basicTable/basicTable';
import { useSelector } from 'react-redux';
import SearchIcon from '@mui/icons-material/Search';
import { permissionsVariables } from '../../../services/Functions';
export default function SupporCenterManagementTable() {
    const [NewcscToDataGrid, setNewcscToDataGrid] = React.useState([]);
    const [open, setOpen] = React.useState(false);
    const [open2, setopen2] = useState(false);
    const [dltcfc, setdltcfc] = useState()
    const [dialogRowData, setDialogRowData] = React.useState({});
    const [tableCFC, setTableCFC] = useState([]) 
    const [viewBackdrop, setViewBackdrop] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
     const [searchQuery, setSearchQuery] = useState("");
    const Navigate = useNavigate();
    const { token, code: userOfficeCode, permissions } = useSelector((state) => state.auth)

    useEffect(() => { 
        const AllCFCSAPI = async () => {
            console.log(userOfficeCode, 'userOfficeCode')
            setViewBackdrop(true)
            try {
                if (CheckPermissions(permissions, permissionsVariables.organizationManagement, "CSC Management")) {
                    var formdata = new FormData();
                    if (userOfficeCode == 10) {
                        formdata.append("companyCode", '');
                    } else {
                        formdata.append("companyCode", parseInt(userOfficeCode.toString().slice(0, 2)));
                    }
                    const myHeaders = new Headers();
                    myHeaders.append("Authorization", token);
                    var requestOptions = {
                        method: 'POST',
                        body: formdata,
                        headers: myHeaders,
                        redirect: 'follow',
                    };
                    await fetch(cfpBaseUrl + "customerFaciliationPortal/getAllCFCs", requestOptions)
                        .then(response => response.json())
                        .then(result => {
                            if (result.status === '200') {
                                const filteredData = result.data;
                                setTableCFC(filteredData);

                            }
                        })
                        .catch(error => console.log('error', error));
                }
            }
            catch (e) {
                console.log(e, 'Unable to load all CFCs')
            }
            setViewBackdrop(false)
        }
        AllCFCSAPI()
    }, [])

    useEffect(() => {
        apiToDataGridConversion()
    }, [tableCFC]);

    const filterNCApp = (cfcid) => {
        const myArray = tableCFC
        let itemFound = myArray.find(item => item.cfcId === cfcid)

        return itemFound;
    }

    const handleClose = () => {
        setOpen(false);
    };

    const handleClose2 = () => {
        setopen2(false);
    };

    const tblColumns = [
        { field: "id", headerName: 'Code', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "name", headerName: ' Name', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "phone", headerName: 'Phone', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "email", headerName: 'Email', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "divisionCode", headerName: 'Division Code', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "address", headerName: 'Address', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "currentstatus", headerName: 'Status', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        {
            headerName: "Action",
            sortable: false,
            align: 'center',
            field: 'buttons',
            headerStyle: tableStyle.headerStyle,
            headerCellStyle: tableStyle.headerCellStyle,
            rowCellStyle: tableStyle.rowCellStyle,
            renderCell: (params) => {
                const onViewCFC = (e) => {
                    e.stopPropagation(); // don't select this row after clicking
                    setDialogRowData(params);
                    setOpen(true);
                };
                const onDeleteCFC = (e) => {
                    e.stopPropagation(); // don't select this row after clicking
                    setopen2(true);
                    setdltcfc(params.id)
                }
                const onEditCFC = (e) => {
                    e.stopPropagation(); // don't select this row after clicking
                    const cfcToEdit = filterNCApp(params.id);
                    Navigate('/support-center-management/UpdateCenterManagement', { state: { cfcToEdit } })
                }

                return (
                    <>
                        <Box>
                            {
                                CheckPermissions(permissions, 'Organization Management', 'CSC Management', 'Read') &&
                                <IconButton onClick={onViewCFC} aria-label="delete" size="small" sx={{ margin: 0.4, padding: 0 }}>
                                    <VisibilityIcon sx={{ color: 'skyblue' }} fontSize='inherit' />
                                </IconButton>
                            }
                            {
                                CheckPermissions(permissions, 'Organization Management', 'CSC Management', 'Update') &&
                                <IconButton aria-label="delete" size="small" sx={{ margin: 0.4, padding: 0 }} onClick={onEditCFC}>
                                    <EditIcon fontSize="inherit" sx={{ color: 'blue' }} />
                                </IconButton>
                            }
                            {
                                CheckPermissions(permissions, 'Organization Management', 'CSC Management', 'Delete') &&
                                <IconButton aria-label="delete" size="small" sx={{ margin: 0, padding: 0 }} onClick={onDeleteCFC}>
                                    <DeleteIcon fontSize="inherit" sx={{ color: 'red' }} />
                                </IconButton>
                            }
                        </Box>
                    </>
                )
            }
        },
    ]

    const apiToDataGridConversion = () => {
        const myArray = tableCFC
        const tempArray = []
        if (myArray) {
            //for(let i = 0; i <= myArray.length; i++){
            myArray.forEach((item) => {
                const dataGridObject = {
                    "id": item.cfcId,
                    "name": item.cfcName,
                    "phone": item.phoneNo,
                    "email": item.email,
                    "divisionCode": item.divisionCode,
                    "address": item.address,
                    "currentstatus": item.currentStatus,

                }
                tempArray.push(dataGridObject)
            })
        }

        setNewcscToDataGrid(tempArray);
        setFilteredData(tempArray);
    }

    const onDelete = async () => {
        setViewBackdrop(true)
        var formdata = new FormData();
        formdata.append("cfcId", dltcfc);

        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow',
        };

        await fetch(cfpBaseUrl + "customerFaciliationPortal/deleteCFC", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status === "200") {
                    let myArray = [...tableCFC]
                    let index = myArray.findIndex(obj => obj.cfcId === dltcfc);
                    myArray.splice(index, 1);
                    setTableCFC(myArray);
                    handleClose2();
                }
            })
            .catch(error => console.log('error', error));
        setViewBackdrop(false)
    }
 const handleSearch = (event) => {
  const value = event.target.value.toLowerCase();
  setSearchQuery(value);

  if (!value) {
    setFilteredData(NewcscToDataGrid);
    return;
  }

const filtered = NewcscToDataGrid.filter((row) =>
    row.id?.toString().toLowerCase().includes(value) ||
    row.name?.toString().toLowerCase().includes(value) ||
    row.phone?.toString().toLowerCase().includes(value) ||
    row.email?.toString().toLowerCase().includes(value) ||
    row.divisionCode?.toString().toLowerCase().includes(value) || // ✅ fixed
    row.address?.toString().toLowerCase().includes(value) ||
    row.currentstatus?.toString().toLowerCase().includes(value)
  );

  setFilteredData(filtered);
};
    return (
        <>
            <Box className='form-box'>
                {/* <Box className='main-heading'>
                    <h2  >
                        Customer Facilitation Centers
                    </h2>
                    <Box className='btn2'>
                        <Link to="new-support-center">
                            <Button variant="contained" size='small' className='btnNewApplication' startIcon={<AddCircleIcon />} >Add Center</Button>
                        </Link>
                    </Box>
                </Box> */}
                 <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                                  <h3 className="page-title">Customer Facilitation Centers Management</h3>
                        
                                  <div
                                    style={{
                                      backgroundColor: "white",
                                      display: "flex",
                                      alignItems: "center",
                                      borderRadius: "10px",
                                      padding: "5px 10px",
                                      border: "1px solid grey",
                                      margin: "0px", 
                                    }}
                                  > 
                                    <input
                                      type="text"
                                      value={searchQuery}
                                      onChange={handleSearch}
                                      placeholder="Search by Code, Name or Phone Or Email Or Address"
                                      maxLength={20}
                                      style={{
                                        flex: 1,
                                        padding: "8px",
                                        border: "none",
                                        backgroundColor: "transparent",
                                        outline: "none",
                                        fontSize: "13px",
                                        minWidth: "300px",
                                      }}
                                    />
                                    <SearchIcon
                                      sx={{
                                        color: "#09669d",
                                        width: 30,
                                        height: 30,
                                        borderRadius: "8px",
                                        padding: "6px",
                                        cursor: "pointer",
                                        transition: "background-color 0.3s",
                                        "&:hover": {
                                          color: "#074f7d",
                                        },
                                      }}
                                    />
                                  </div>
                                </Box>
                <Box className='application-table'>
                    <BasicTable
                        data={filteredData}
                        columns={tblColumns}
                        sx={tableStyle}
                        rowHeight={37.5}
                        pageSize={18}
                        rowsPerPageOptions={[18, 30, 60]}
                        rowsPageOption={false}
                        getRowStyle={(params) => {
                            return params.indexRelativeToCurrentPage % 2 === 0 ? tableStyle.evenRow : tableStyle.oddRow
                        }}
                    />
                </Box>
            </Box>

            {/* <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{ sx: { width: '30%' } }}
            >
                <DialogTitle id="alert-dialog-title" className="dialog-title">
                    <IconButton onClick={handleClose} sx={{ position: "relative", float: 'right' }}>
                        <CloseIcon />
                    </IconButton>
                    <Typography sx={{ fontWeight: 'bold' }}>Customer Facilitation Center Details</Typography>
                </DialogTitle>
                <DialogContent className='dialog-content'>
                    <DialogContentText id="alert-dialog-description">
                        <hr />
                        <Grid className='content-grid' sx={{ mt: '17px', display: 'flex', flexDirection: "column" }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column' }}>

                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5>Division code:</h5><p>{dialogRowData.divisionCode}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5>Office code:</h5><p>{dialogRowData.id}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5>Name:</h5><span>{dialogRowData.name}</span>
                                </Box>

                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5>E-mail:</h5><span>{dialogRowData.email}</span>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5>status:</h5><p>{dialogRowData.currentstatus}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5>Address:</h5><p>{dialogRowData.address}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Phone No:</h5><span style={{ marginBottom: '30px' }}>{dialogRowData.phone}</span>
                                </Box>
                                <hr />
                            </Box>
                        </Grid>
                    </DialogContentText>
                </DialogContent>
            </Dialog> */}
            <Dialog
  open={open}
  onClose={handleClose}
  fullWidth
  maxWidth="sm"
  PaperProps={{ sx: { borderRadius: 3, maxWidth: 700 } }}
>
  <DialogTitle
    sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
    className="dialog-title"
  >
    Customer Facilitation Center Details
    <IconButton onClick={handleClose} sx={{ color: 'black' }}>
      <CloseIcon />
    </IconButton>
  </DialogTitle>

  <DialogContent className="dialog-content">
    <DialogContentText sx={{ minHeight: 300 }}>
      <Grid container spacing={2} sx={{ padding: '20px' }}>
        <Grid item xs={12}>
          <Box sx={{ backgroundColor: '#d5e5ff', padding: '5px' }}>
            <h4 style={{ color: '#006ad1' }}>General Information</h4>
          </Box>
        </Grid>

        {[
          { label: 'Division Code', value: dialogRowData.divisionCode },
          { label: 'Office Code', value: dialogRowData.id },
          { label: 'Name', value: dialogRowData.name },
          { label: 'Email', value: dialogRowData.email },
          { label: 'Status', value: dialogRowData.currentstatus },
          { label: 'Address', value: dialogRowData.address },
          { label: 'Phone No.', value: dialogRowData.phone },
        ].map((item, index) => (
          <Grid item xs={12} sm={6} key={index}>
            <label style={{ fontWeight: 600 }}>{item.label}</label>
            <TextField
              value={item.value || '-'}
              fullWidth
              disabled
              size="small"
              sx={{ mt: 0.5 }}
            />
          </Grid>
        ))}
      </Grid>
    </DialogContentText>
  </DialogContent>
</Dialog>


            <Dialog
                open={open2}
                onClose={handleClose2}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {" Are you sure to delete this record"}
                </DialogTitle>
                <DialogActions>
                    <Button onClick={handleClose2}>Cancel</Button>
                    <Button onClick={onDelete} autoFocus>
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Backdrop */}
            < Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                open={viewBackdrop}
            >
                <CircularProgress color="inherit" />
            </Backdrop >
        </>
    )
}
